'use client';

import { type FC } from 'react';
import type { VoidCallback } from '@/type-utils';
import { Curtain } from '../../Curtain';

/**
 * Props for the DrawerPortal component.
 */
export interface IDrawerPortalProps {
  /**
   * Whether to show the curtain overlay.
   */
  showCurtain: boolean;
  /**
   * Function to close all drawers.
   */
  closeAllDrawers: VoidCallback;
  /**
   * Additional CSS classes for the curtain.
   */
  curtainClassName: string;
}

/**
 * Portal component that renders the curtain overlay for the drawer.
 * Separated from main Drawer component for better maintainability.
 * The main reason for the portal is to ensure that the curtain is properly positioned.
 * It should be above the main content of the page but whether it covers the header or not is brand specific.
 *
 * This separate component is used to emphasize that the createPortal function is used to render this component once,
 * but whether the curtain itself is rendered or not is controlled by the showCurtain prop.
 */
export const DrawerPortal: FC<IDrawerPortalProps> = ({
  showCurtain,
  closeAllDrawers,
  curtainClassName
}) => {
  return (
    <>
      {showCurtain && (
        <Curtain onClose={closeAllDrawers} className={curtainClassName} />
      )}
    </>
  );
};
